import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-test-error',
  templateUrl: './test-error.component.html',
  styleUrls: ['./test-error.component.css']
})
export class TestErrorComponent implements OnInit {

  constructor(private http: HttpClient, private alertsCenterService: AlertsCenterService) {}

  ngOnInit() {

      const http$ = this.getEvento(123); 

      http$.subscribe(
          res => console.log('HTTP response', res),
          err => {
            console.log('HTTP Error', err)
            this.alertsCenterService.showAlert({
                message: `Errore durante questa verissima operazione di test`,
                type: 'danger',
                autoClosable: false
            });
          },
          () => console.log('HTTP request completed.')
      );
  }

  public getEvento(idEvento: number) {
    return this.http
      .get<ModelEventiCalamitosi.EventoDto>(`${environment.urls.base}/evento/id/${idEvento}`);
  }
}